export enum ApprobationExplanationDialogFormNamesEnum {
  FORM_GROUP_NAME = 'ClosingExplanation',
  REASON_CODE = 'ReasonCode',
  REASON_EXPLANATION = 'ReasonExplanation',
}
